import React from "react";
import {Row, Col, DropdownButton, MenuItem} from "react-bootstrap";
import {translate} from '../../i18n/translate.js';

class JoinPickupSiteFilter extends React.Component {
    state = {
        deliveryDay: this.props.deliveryDayFilter
    };

    componentWillReceiveProps(nextProps) {
        if(nextProps.deliveryDayFilter !== this.props.deliveryDayFilter) {
            this.setState({deliveryDayFilter: nextProps.deliveryDayFilter});
        }
    }

    onChangeDeliveryDay = (value) => {
        let deliveryDay = value==='All'?null:value;
        this.setState({deliveryDay: deliveryDay});
        this.props.setDeliveryDayFilter(deliveryDay);
    };

    createSelection = () => {
        let days = [];
        let selectedDays = [];
        if(this.props.pickupSites) {
            for(let i in this.props.pickupSites) {
                if(this.props.pickupSites.hasOwnProperty(i)) {
                    let pickupSite = this.props.pickupSites[i];
                    let deliveryDay = pickupSite.deliveryDaysList ? pickupSite.deliveryDaysList[0] : undefined;
                    if (!days.includes(deliveryDay)) {
                        days.push(deliveryDay);
                    }
                }
            }
            if(days) {
                this.sortDays(days).forEach(function(deliveryDay){
                    selectedDays.push(<MenuItem key={deliveryDay} eventKey={deliveryDay}>{translate(deliveryDay)}</MenuItem>);
                })
            }
            return (
                <DropdownButton title={translate(!this.state.deliveryDay ? 'All' : this.state.deliveryDay)} className="select-day"
                                id="delivery-day-menu" onSelect={this.onChangeDeliveryDay}>
                    <MenuItem key="All" eventKey="All">{translate("All")}</MenuItem>
                    {selectedDays}
                </DropdownButton>)
        }
    };

    sortDays = (days) => {
        const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        return days.sort(function (a, b) {
            return (weekDays.indexOf(a) - weekDays.indexOf(b));
        }.bind(days));
    };

    render() {
        if(this.props.clientViewPort.isXs) {
            return (<Row className={"pickup-site-filter-container"}>
                <Col xs={4} className="pickup-site-filter-col">
                    <label className="pickup-site-filter-label">{translate("Filter by day")}</label>
                </Col>
                <Col xs={8} className="pickup-site-filter-col">
                    {this.createSelection()}
                </Col>
            </Row>);
        } else {
            return (<Row className="pickup-site-filter-container">
                <Col sm={4} className="pickup-site-filter-day">
                    <div className="pickup-site-filter-label">{translate("Filter by day")}</div>
                    {this.createSelection()}
                </Col>
            </Row>);
        }
    }
}
export default JoinPickupSiteFilter;



// WEBPACK FOOTER //
// ./src/components/join/JoinPickupSiteFilter.js